import { type CommandProperties, createCommand } from '@canvas/rovo-content-bridge-api';

import { type NativeEmbedFeatureList } from '../types.ts';

/**
 * @see {@link EnabledFeaturesCommand}
 */
export interface EnabledFeaturesCommandProperties extends CommandProperties {
  features: NativeEmbedFeatureList;
}

/**
 * A command to "handshake" the enabled features on the databases client and the
 * external client that is interacting.
 */
export const EnabledFeaturesCommand = createCommand<
  EnabledFeaturesCommandProperties,
  NativeEmbedFeatureList
>('enabled-features-command');
